<template>
  <dir>
    <c-modal persistent v-model="shouldShowPrompt">
      <template v-if="!gettingTxObject">
        <div class="text-4 line-height-25 darkgray--text text-justify">
          You have an allowance approval on a compromised contract. You need to
          revoke the approval to protect your funds.
        </div>
        <div class="mt-10 d-flex align-center justify-end">
          <div
            class="text-4 font-weight-medium gray--text clickable"
            @click="shouldShowPrompt = false"
          >
            Cancel
          </div>
          <c-btn class="ml-5" @click="revoke">Revoke</c-btn>
        </div>
      </template>
      <c-loading v-else loadingText="Please wait"></c-loading>
    </c-modal>
    <tx-ethereum
      v-if="shouldShowApproveModal"
      title="Revoke allowance approval"
      name="approve"
      broadcastAction="vaults/broadcastTx"
      :broadcastMetadata="{ vault: vaultInfo.type, token: vaultInfo.token }"
      :txObject="txObject"
      :txFees="txFees"
      :quiet="true"
    >
    </tx-ethereum>
  </dir>
</template>

<script>
import { mapGetters } from "vuex";
import BN from "bignumber.js";

export default {
  props: {
    vaultInfo: Object,
  },
  computed: {
    ...mapGetters({
      compromisedZapAllowance: "vaults/compromisedZapAllowance",
    }),
  },
  data: () => ({
    shouldShowPrompt: false,
    shouldShowApproveModal: false,
    gettingTxObject: false,
    txObject: null,
  }),
  watch: {
    ["compromisedZapAllowance.allowance"](value) {
      if (value > 0) {
        this.shouldShowPrompt = true;
      } else {
        this.shouldShowPrompt = false;
      }
    },
  },
  methods: {
    async revoke() {
      this.gettingTxObject = true;
      this.txObject = await this.$store.dispatch(
        "vaults/getWethV3ZapRevokeAllowanceRawTx"
      );
      const amount = new BN(this.txObject.gas || 0)
        .multipliedBy(this.txObject.maxFeePerGas || 0)
        .dividedBy(1e18)
        .toNumber();
      this.txFees = {
        amount,
      };
      this.gettingTxObject = false;
      this.shouldShowPrompt = false;
      this.shouldShowApproveModal = true;
    },
  },
};
</script>
